var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4491 4.365C11.9366 3.77965 11.6541 3.02805 11.6541 2.25H9.33664V11.55C9.31914 12.0534 9.10678 12.5303 8.74437 12.8801C8.38196 13.2299 7.89784 13.4253 7.39414 13.425C6.32914 13.425 5.44414 12.555 5.44414 11.475C5.44414 10.185 6.68914 9.2175 7.97164 9.615V7.245C5.38414 6.9 3.11914 8.91 3.11914 11.475C3.11914 13.9725 5.18914 15.75 7.38664 15.75C9.74164 15.75 11.6541 13.8375 11.6541 11.475V6.7575C12.5939 7.43239 13.7222 7.79448 14.8791 7.7925V5.475C14.8791 5.475 13.4691 5.5425 12.4491 4.365Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktok);
export default __webpack_public_path__ + "static/media/ic_tiktok.d65663e6811fed0224ca6d4c9d7a8e1f.svg";
export { ForwardRef as ReactComponent };